export const ENQUEUE_SNACKBAR = 'CORE|ENQUEUE_SNACKBAR';
export const REMOVE_SNACKBAR = 'CORE|REMOVE_SNACKBAR';
